import { parseDate, COMPLETE_MONTH } from '@tcp/core/src/utils/parseDate';
import toTimeString from '@tcp/core/src/utils/formatTime';
import { isAndroid, getDateObject } from '@tcp/core/src/utils';

export const getDateSuffix = (date) => {
  if (date > 3 && date < 21) {
    return 'th';
  }
  switch (date % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const isHolidayThere = (data, from, toDateDayCount = 14) => {
  // Setting to 14 days by default as a siteconfig fallback
  let isHoliday = false;
  const fromDate = getDateObject(parseDate(from));
  const toDate = getDateObject(fromDate?.getTime() + toDateDayCount * 24 * 60 * 60 * 1000);
  const parseTimeStr = (timeStr) => {
    try {
      return toTimeString(parseDate(timeStr));
    } catch (err) {
      return timeStr;
    }
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const item of data) {
    const date = getDateObject(parseDate(item?.openIntervals?.[0]?.fromHour));
    if (date >= fromDate && date <= toDate) {
      isHoliday = item;
      isHoliday.date = item?.openIntervals?.[0]?.fromHour;
      isHoliday.value = item?.openIntervals.map(
        (i) => `${parseTimeStr(i.fromHour)} - ${parseTimeStr(i.toHour)}`
      );
      isHoliday.closed = item?.isClosed || false;
      break;
    }
  }
  return isHoliday;
};

export const getHolidayDate = (rawDate) => {
  const date = getDateObject(parseDate(rawDate));
  const dayNum = date.getDate();
  const dayNumSuffix = getDateSuffix(dayNum);
  const month = isAndroid()
    ? COMPLETE_MONTH[date?.getMonth()]
    : date.toLocaleString('default', { month: 'long' });
  return `${dayNum}${dayNumSuffix} ${month}`;
};
